module.exports = __webpack_public_path__ + "static/media/HHNav.3b891564.png";